import React from 'react';
import PropTypes from 'prop-types';
import Styled from 'styled-components';

const SIZE = {
	SMALL: 'small',
	STANDARD: 'standard',
};
export const CrossIcon = ({size, color, onClick, cy}) => {
	const getWidth = size => {
		switch (size) {
			case SIZE.SMALL:
				return '16';
			case SIZE.STANDARD:
				return '24';
			default:
				return '24';
		}
	};
	const getHeight = size => {
		switch (size) {
			case SIZE.SMALL:
				return '16';
			case SIZE.STANDARD:
				return '24';
			default:
				return '24';
		}
	};

	const handleClick = e => {
		/*
			We only want to stop propagation if onClick is set i props
			otherwise we want the click to propagate up
		*/
		if (onClick) {
			e.stopPropagation();
			onClick(e);
		}
	};

	return (
		<StyledSpan data-cy={cy} onClick={handleClick} width={getWidth(size)} height={getHeight(size)}>
			<svg
				idth={getWidth(size)}
				height={getHeight(size)}
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M6.77426 5.92574C6.53995 5.69142 6.16005 5.69142 5.92574 5.92574C5.69142 6.16005 5.69142 6.53995 5.92574 6.77426L11.1515 12L5.92574 17.2257C5.69142 17.46 5.69142 17.8399 5.92574 18.0743C6.16005 18.3086 6.53995 18.3086 6.77426 18.0743L12 12.8485L17.2257 18.0743C17.4601 18.3086 17.8399 18.3086 18.0743 18.0743C18.3086 17.8399 18.3086 17.4601 18.0743 17.2257L12.8485 12L18.0743 6.77426C18.3086 6.53995 18.3086 6.16005 18.0743 5.92574C17.8399 5.69142 17.46 5.69142 17.2257 5.92574L12 11.1515L6.77426 5.92574Z"
					fill={color}
				/>
			</svg>
		</StyledSpan>
	);
};
CrossIcon.SIZE = SIZE;
CrossIcon.propTypes = {
	onClick: PropTypes.func,
	color: PropTypes.string.isRequired,
	size: PropTypes.oneOf([SIZE.SMALL, SIZE.STANDARD]),
	cy: PropTypes.string,
};

CrossIcon.defaultProps = {
	color: '#565656',
};
const StyledSpan = Styled.span`
	cursor: pointer;
	display: flex;
	height: ${props => props.height + 'px'};
	width: ${props => props.width + 'px'};
	align-self: center;
`;
